import React from 'react';

const creators = [
  {
    initials: 'LM',
    color: '#68C1AE',
    name: 'Lina Marek',
    handle: '@linawatch',
    description: 'Stockholm-based designer blending typography-focused faces perfect for productivity sessions.',
    tag: 'Typography',
  },
  {
    initials: 'MS',
    color: '#A87CDC',
    name: 'The Midnight Studio',
    handle: '@midnightwatch',
    description: 'Cinematic, neon-lit gradients with subtle motion for the always-on display.',
    tag: 'Cinematic',
  },
  {
    initials: 'RC',
    color: '#F0C56E',
    name: 'River & Co',
    handle: '@riverwidgets',
    description: 'Widget stacks for travellers — time zones, weather bands, and quick routes at a glance.',
    tag: 'Travel',
  },
];

const CreatorSpotlight: React.FC = () => (
  <section
    id="creators"
    className="py-24"
    style={{ background: '#080C0B' }}
  >
    <div className="container mx-auto">
      <div className="text-center mb-14">
        <span className="section-badge mb-4 inline-flex">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#68C1AE]" />
          The makers
        </span>
        <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight" style={{ letterSpacing: '-0.03em' }}>
          Creator{' '}
          <span className="gradient-text">Spotlights</span>
        </h2>
        <p className="mt-4 text-lg text-white/45 max-w-xl mx-auto">
          We celebrate the artists and developers behind the most loved watch setups. Submit yours to get featured.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-3">
        {creators.map((creator) => (
          <article
            key={creator.handle}
            className="rounded-3xl p-7 hover-lift relative overflow-hidden"
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.07)',
            }}
          >
            {/* Avatar */}
            <div className="flex items-center gap-4 mb-5">
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center font-bold text-sm text-[#080C0B]"
                style={{ background: creator.color }}
              >
                {creator.initials}
              </div>
              <div>
                <h3 className="text-base font-bold text-white leading-snug">{creator.name}</h3>
                <p className="text-sm mt-0.5" style={{ color: creator.color }}>{creator.handle}</p>
              </div>
            </div>

            <span
              className="text-[11px] font-bold uppercase tracking-widest px-3 py-1 rounded-full"
              style={{
                background: `${creator.color}18`,
                color: creator.color,
                border: `1px solid ${creator.color}30`,
              }}
            >
              {creator.tag}
            </span>

            <p className="mt-4 text-[15px] text-white/50 leading-relaxed">{creator.description}</p>

            <button
              className="mt-6 text-sm font-semibold flex items-center gap-1.5 transition-colors duration-200"
              style={{ color: creator.color }}
            >
              View collection
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>

            {/* Glow blob */}
            <div
              className="absolute -bottom-8 -right-8 w-28 h-28 rounded-full pointer-events-none"
              style={{ background: `${creator.color}18`, filter: 'blur(20px)' }}
            />
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default CreatorSpotlight;
